__turbopack_context__.v({
  "form": "styles-module__ofN86W__form",
  "loader": "styles-module__ofN86W__loader",
});
